import style from './style.css';
import { useEffect } from 'preact/hooks';
import LendersCard from './lendersCard';
import BenefitsSection from './benefitsSection';
import { tracker, PageLoadType } from '../../../tracking';
import { getLenderNames } from '../../../utils/stringOperations';

const OverlayEmiDetails = (props) => {
  const { handleCloseOverlay, lenderDetailsList } = props || {};
  const pageKey = 'pv_bic_preapproved_overlay';

  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      handleCloseOverlay(false);
    }
  };

  useEffect(() => {
    tracker.trackPageView(PageLoadType.DYNAMIC, pageKey, {
      lenderList: getLenderNames(lenderDetailsList),
    });
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return (
    <div className={style.overlayEmiDetailsContainer}>
      <div className={style.headerText}>
        <img
          src='https://iccdn.in/img/widget-img/circularTickAnimation.gif'
          alt='congratulations'
          className={style.tickLogo}
        />
        Congratulations!
      </div>
      <div className={style.preapprovedContainer}>
        <div className={style.preApprovedText}>
          You are pre-approved for Cardless EMI
        </div>
      </div>
      <LendersCard lenderDetailsList={lenderDetailsList} />
      <BenefitsSection />
    </div>
  );
};

export default OverlayEmiDetails;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEmiDetails/index.js